<template>
  <v-row class="mx-auto">
    <v-col cols="12">
      <v-card outlined :loading="loading" :disabled="loading">
        <v-card-title class="subtitle-1">{{ dynamicLabel }}</v-card-title>
        <v-card-text v-if="!readonly">
          <div class="d-flex align-center">
            <v-btn class="mr-2" color="primary" @click="clickAddNewCard()"><v-icon left>mdi-plus</v-icon>Adicionar</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col
      sm="6"
      v-for="(lineSelected, index) in lineSelect"
      :key="index"
    >
      <v-card outlined class="mx-auto">
        <v-card-title class="primary white--text">
          <div class="headerClass" v-if="lineSelected">
            {{ lineSelected.document_type && lineSelected.document_type.name ? lineSelected.document_type.name : 'Selecione Tipo Documento' }}
            <v-chip
              v-if="lineSelected.approve"
              :color="lineSelected.approve.approve ? 'green darken-1' : 'red darken-1'"
              small
              class="ml-3 white--text"
              label
            >
              {{ lineSelected.approve.approve ? 'Aprovado' : 'Reprovado' }}
            </v-chip>
          </div>
          <v-spacer></v-spacer>
          <v-tooltip top v-if="page === 'approval'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" class="pr-2" color="white" :loading="loadingCopyLink" @click="copyLinkDocument(index)">
                <v-icon color="white">mdi-content-copy</v-icon>
              </v-btn>
            </template>
            <span>Copiar link</span>
          </v-tooltip>
          <v-tooltip top v-if="page === 'approval'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="openApprovalDetail(index)">
                <v-icon color="white">mdi-file-document-outline</v-icon>
              </v-btn>
            </template>
            <span>Visualizar documento</span>
          </v-tooltip>
          <v-btn
            v-if="!readonly"
            icon
            class="ml-1"
            @click="closeLine(index)"
          >
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" class="mt-5">
              <v-autocomplete
                v-model="lineSelected.document_type"
                :items="[
                  {
                    'value': 1,
                    'name': 'Termo Adesão',
                  },
                  {
                    'value': 2,
                    'name': 'Termo Devolução',
                  },
                ]"
                label="Tipo Documento"
                item-value="value"
                item-text="name"
                return-object
                :clearable="!readonly"
                :readonly="readonly"
                outlined
                dense
                :rules="[v => (v && Object.keys(v).length > 0) || 'Obrigatório']"
                @change="
                  updateParams($event, index, 'document_type');
                  clearAllFields(index);
                  updateValues;"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" v-if="lineSelected.document_type && lineSelected.document_type.value == 1">
              <PersonField
                :readonly="readonly"
                :selectedPerson="lineSelected.person"
                :rules="[v => (v && Object.keys(v).length > 0) || 'Obrigatório']"
                @save="updateSelectedField($event, index, 'person')"
              />
            </v-col>

            <v-col cols="12" v-if="showFieldLine(lineSelected)">
              <LineComponent
                :readonly="readonly"
                :selectedLine="lineSelected.line"
                :rules="[validateDeviceOrLine(lineSelected)]"
                :searchParams="lineSelected.searchParams || {}"
                @save="updateSelectedLine($event, index)"
              ></LineComponent>
            </v-col>

            <v-col cols="12" v-if="showFieldMovtoDeviceLine(lineSelected)">
              <v-text-field
                label="Aparelho Linha"
                :value="lineSelected.line.imei + ' - ' + lineSelected.line.fabricante + ' ' + lineSelected.line.modelo"
                outlined
                disabled
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" v-if="showFieldMovtoDeviceLine(lineSelected)">
              <v-autocomplete
                v-model="lineSelected.movto_device_line"
                :items="getItemsMovtoDeviceLine(lineSelected.document_type.value)"
                label="Movimento Aparelho Linha"
                item-value="value"
                item-text="name"
                return-object
                :clearable="!readonly"
                :readonly="readonly"
                :rules="[v => (v && Object.keys(v).length > 0) || 'Obrigatório']"
                outlined
                dense
                @change="updateSelectedMovtoDeviceLine($event, index)"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" v-if="showFieldBaixarDeviceLine(lineSelected)">
              <v-autocomplete
                v-model="lineSelected.baixar_device_line"
                :items="GROUP_TIPO_BAIXA"
                label="Tipo Baixa"
                item-value="value"
                item-text="name"
                return-object
                :clearable="!readonly"
                :readonly="readonly"
                :rules="[v => (v && Object.keys(v).length > 0) || 'Obrigatório']"
                outlined
                dense
                @change="updateValues"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" v-if="showFieldDevice(lineSelected)">
              <DeviceField
                :selectedDevice="lineSelected.device"
                :readonly="readonly"
                :rules="[validateDeviceOrLine(lineSelected)]"
                @save="updateSelectedDevice($event, index)"
              ></DeviceField>
            </v-col>

            <v-col cols="12" v-if="showFieldMovtoDevice(lineSelected)">
              <v-autocomplete
                v-model="lineSelected.movto_device"
                :items="[
                  {
                    'value': 4,
                    'name': 'Enviar para Estoque',
                  },
                  {
                    'value': 5,
                    'name': 'Baixar Aparelho',
                  },
                ]"
                label="Movimento Aparelho"
                item-value="value"
                item-text="name"
                return-object
                :clearable="!readonly"
                :readonly="readonly"
                outlined
                dense
                @change="updateValues"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" v-if="lineSelected.document_type && lineSelected.document_type.value == 2 && lineSelected.device && lineSelected.device.id_aparelho && lineSelected.movto_device && lineSelected.movto_device.value == 5">
              <v-autocomplete
                v-model="lineSelected.baixar_device"
                :items="GROUP_TIPO_BAIXA"
                label="Tipo Baixa"
                item-value="value"
                item-text="name"
                return-object
                :clearable="!readonly"
                :readonly="readonly"
                outlined
                dense
                @change="updateValues"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" v-if="lineSelected.document_type && lineSelected.document_type.value == 1 && lineSelected.line && lineSelected.line.id_linha">
              <IccidField
                :readOnlyField="readonly"
                :chipSelected="lineSelected.iccid"
                :ddd="lineSelected.line ? lineSelected.line.ddd : ''"
                @changeData="updateSelectedField($event, index, 'iccid')"
              />
            </v-col>

            <v-col cols="12" v-if="lineSelected.document_type">
              <v-autocomplete
                v-model="lineSelected.reason"
                :items="[
                {
                  'value': 1,
                  'name': 'Backup',
                },
                {
                  'value': 2,
                  'name': 'Troca Titularidade',
                },
              ]"
                label="Motivo"
                item-value="value"
                item-text="name"
                return-object
                :clearable="!readonly"
                :readonly="readonly"
                outlined
                dense
                @change="
                  updateSelectedField('', index, 'ticket');
                  updateSelectedField($event, index, 'reason')
                "
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" v-if="lineSelected.document_type">
              <v-text-field
                v-if="lineSelected.reason && lineSelected.reason.value === 1"
                label="Ticket"
                :value="lineSelected.ticket"
                outlined
                :readonly="readonly"
                dense
                :rules="[v => !!v || 'O campo é obrigatório']"
                @change="updateSelectedField($event, index, 'ticket')"
              ></v-text-field>
            </v-col>
            <v-col v-if="lineSelected.document_type">
              <v-textarea
                label="Descrição"
                v-model="lineSelected.description"
                outlined
                dense
                :readonly="readonly"
                @change="updateSelectedField($event, index, 'description')"
                v-if="!loading"
                :rules="[v => !!v || 'O campo é obrigatório']"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <SuspendLineDateFields
                v-if="!loading && page === 'interaction'"
                :index="index"
                :default_label_date="'Data Assinatura'"
                :default_label_hour="'Hora Assinatura'"
                :default_date="lineSelected.data_assinatura"
                :default_hour="lineSelected.hr_assinatura"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import LineComponent from "@/components/forms/LineComponent.vue";
import isEmpty from "lodash/isEmpty";
import PersonField from "../fields/PersonField.vue";
import IccidField from "../fields/IccidField.vue";
import DeviceField from "../fields/DeviceField.vue";
import SuspendLineDateFields from "../customFieldsComponents/SuspendLineDateFields.vue";
import { GROUP_TIPO_BAIXA } from "../../helpers/constants";
export default {
  components: { SuspendLineDateFields, DeviceField, IccidField, PersonField, LineComponent },
  props: {
    index: {},
    groupUser: {},
    uniqueKeyStorage: {
      type: String,
      default: ''
    },
    page: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    defaultValues: {
      type: Array,
      default: () => []
    },
    field: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loadingCopyLink: false,
      lineSelect: [],
      loading: true,
      show: false,
      showModalImport: false,
      maxLength: 50,
      dynamicLabel: "Gerar Termo",
      resultStorage: null,
      lineRules: [v => !!v || "Linha é obrigatório"],
      searchLines: {}
    };
  },
  async mounted() {
    if (this.page === 'interaction') {
      this.readonly = true;
      this.lineSelect = this.field.values;
      await this.updateValues();
    }
    if (this.page === 'validate') {
      this.$emit('componentLoading', true);
    }

    if (this.page === 'wizard') {
      if (this.wizard.model["gerar_termo"]) {
        this.wizard.forms.map(form => {
          if (form.type === "gerar_termo") {
            this.dynamicLabel = form.label;
          }
        });
      }

      this.lineSelect = [...this.lineSelect, {}];

      const dataLocalStorage = await this.loadDataLocalStorage(this.uniqueKeyStorage);
      if (!isEmpty(dataLocalStorage) && this.page === 'wizard') {
        this.resultStorage = dataLocalStorage;
        this.lineSelect = Object.assign([], this.resultStorage);
      }
    }

    if (this.defaultValues.length > 0) {
      this.lineSelect = this.defaultValues;
    }

    if (this.page === 'validate') {
      await this.updateValues();
      this.$emit('componentLoading', false);
    }
    this.loading = false;
  },
  computed: {
    ...mapState("packages", ["lines"]),
    ...mapState("forms", ["wizard"]),
    ...mapState("solicitation", ["solicitation_validate_values","link_gerar_termo"]),
    GROUP_TIPO_BAIXA() {
      return GROUP_TIPO_BAIXA
    },
  },
  methods: {
    ...mapActions("solicitation", ["loadDataLocalStorage","setAutomationComponentValues","loadLinkApproveGerarTermo"]),
    ...mapActions("interaction", ["setAutomationComponentFields"]),
    ...mapMutations("forms", ["SET_FORM_EMAIL"]),
    ...mapMutations({setModel: "forms/setModelResetLine"}),
    async clickAddNewCard() {
      if (this.lineSelect.length >= this.maxLength) {
        await this.$swal("Limite máximo atingido", 'O número máximo de cards dessa solicitação é '+this.maxLength+'.', "info");
      } else {
        this.lineSelect = [{}, ...this.lineSelect];
      }
    },
    showFieldLine(lineSelected) {
      if (lineSelected.document_type && lineSelected.document_type.value == 2) {
        return !(lineSelected.device && lineSelected.device.id_aparelho);
      } else if (lineSelected.document_type && lineSelected.document_type.value == 1) {
        return true;
      }
      return false;
    },
    showFieldMovtoDeviceLine(lineSelected) {
      if (lineSelected.document_type) {
        return lineSelected.document_type && lineSelected.line && lineSelected.line.id_aparelho;
      }
      return false;
    },
    showFieldBaixarDeviceLine(lineSelected) {
      if (lineSelected.document_type) {
        return lineSelected.document_type && lineSelected.line && lineSelected.line.id_aparelho && lineSelected.movto_device_line && lineSelected.movto_device_line.value == 5;
      }
      return false;
    },
    showFieldDevice(lineSelected) {
      if (lineSelected.document_type && lineSelected.document_type.value == 2) {
        return !(lineSelected.line && lineSelected.line.id_linha);
      } else if (lineSelected.document_type && lineSelected.document_type.value == 1) {
        return !(lineSelected.line && lineSelected.line.id_aparelho && lineSelected.movto_device_line && lineSelected.movto_device_line.value == 6);
      }
      return false;
    },
    showFieldMovtoDevice(lineSelected) {
      if (lineSelected.document_type && lineSelected.document_type.value == 2) {
        return lineSelected.document_type && lineSelected.document_type.value == 2 && lineSelected.device && lineSelected.device.id_aparelho;
      }
      return false;
    },
    getItemsMovtoDeviceLine(document_type) {
      let items = [
        {
          'value': 4,
          'name': 'Enviar para Estoque',
        },
        {
          'value': 5,
          'name': 'Baixar Aparelho',
        },
        {
          'value': 7,
          'name': 'Manter Titular',
        },
      ];
      if (document_type == 1) {
        items.push({
          'value': 6,
          'name': 'Troca Titularidade',
        });
      }
      return items;
    },
    validateDeviceOrLine(lineSelected) {
      return () => {
        if ((lineSelected.device && Object.keys(lineSelected.device).length > 0) || (lineSelected.line && Object.keys(lineSelected.line).length > 0)) {
          return true
        }
        return 'É obrigatório selecionar pelo menos Aparelho ou Linha'
      }
    },
    async updateSelectedLine(lineSelected, index) {
      const exists = this.lineSelect.some((line, i) => line['line'] && line['line'].id_linha === lineSelected.id_linha && i !== index);
      const exists_aparelho =
        this.lineSelect.some((value, i) => value['line'] && value['line'].id_aparelho != '' && value['line'].id_aparelho === lineSelected.id_aparelho && i !== index) ||
        this.lineSelect.some((value, i) => value['device'] && value['device'].id_aparelho != '' && value['device'].id_aparelho === lineSelected.id_aparelho && i !== index);

      if (exists) {
        await this.updateSelectedField([], index, 'line');
        await this.$swal("Linha já selecionada!", "", "warning");
        return;
      }

      if (exists_aparelho) {
        await this.updateSelectedField([], index, 'line');
        await this.$swal("Aparelho Linha já selecionado!", "", "warning");
        return;
      }
      await this.updateSelectedField(lineSelected, index, 'line');
      if (lineSelected.document_type == 2) {
        await this.updateSelectedField([], index, 'device');
        await this.updateSelectedField([], index, 'movto_device');
        await this.updateSelectedField([], index, 'baixar_device');
      }

      if (!lineSelected.id_linha) {
        await this.updateSelectedField([], index, 'movto_device_line');
        await this.updateSelectedField([], index, 'baixar_device_line');
      }
    },

    async updateSelectedDevice(lineSelected, index) {
      const exists =
        this.lineSelect.some((value, i) => value['device'] && value['device'].id_aparelho === lineSelected.id_aparelho && i !== index) ||
        this.lineSelect.some((value, i) => value['line'] && value['line'].id_aparelho === lineSelected.id_aparelho && i !== index);

      if (exists) {
        await this.updateSelectedField([], index, 'device');
        await this.$swal("Aparelho já selecionado!", "", "warning");
        return;
      }
      await this.updateSelectedField(lineSelected, index, 'device');
      if (lineSelected.document_type == 2) {
        await this.updateSelectedField([], index, 'line');
        await this.updateSelectedField([], index, 'movto_device_line');
        await this.updateSelectedField([], index, 'baixar_device_line');
      }
      if (!lineSelected.id_aparelho) {
        await this.updateSelectedField([], index, 'movto_device');
        await this.updateSelectedField([], index, 'baixar_device');
      }
    },

    async updateSelectedMovtoDeviceLine(lineSelected, index) {
      await this.updateSelectedField(lineSelected, index, 'movto_device_line');
      if (lineSelected.value && lineSelected.value == 6) {
        await this.updateSelectedField([], index, 'device');
      }
      await this.updateSelectedField([], index, 'baixar_device_line');
    },

    async updateSelectedField(value, index, field) {
      this.loading = true;
      this.lineSelect[index][field] = value;
      this.lineSelect = Object.assign([], this.lineSelect);
      await this.updateValues();
      this.loading = false;
    },
    updateParams(value, index, param) {
      let status_line = '';
      if (param === 'document_type' && value.value) {
        status_line = value.value == 2 ? 0 : '';
      }

      this.$set(this.lineSelect[index], 'searchParams', {
        show_device: true,
        status_line,
      });
    },
    async clearAllFields(index) {
      await this.updateSelectedField([], index, 'line');
      await this.updateSelectedField([], index, 'reason');
      await this.updateSelectedField([], index, 'iccid');
      await this.updateSelectedField('', index, 'ticket');
      await this.updateSelectedField([], index, 'person');
      await this.updateSelectedField([], index, 'device');
      await this.updateSelectedField([], index, 'movto_device_line');
      await this.updateSelectedField([], index, 'baixar_device_line');
      await this.updateSelectedField([], index, 'device');
      await this.updateSelectedField([], index, 'movto_device');
      await this.updateSelectedField([], index, 'baixar_device');
    },
    async updateValues() {
      if (this.page === 'validate') {
        await this.setAutomationComponentValues({
          automation: "gerar_termo",
          data: { gerar_termo: this.lineSelect }
        });
        this.SET_FORM_EMAIL({});
        this.SET_FORM_EMAIL(this.solicitation_validate_values);

      } else if (this.page === 'wizard') {
        const payload = {
          step: this.index,
          selected: this.lineSelect
        };
        this.setModel(payload);
        localStorage.setItem(this.uniqueKeyStorage, JSON.stringify(this.lineSelect));
      } else if (this.page === 'interaction'){
        await this.setAutomationComponentFields({
          automation: "gerar_termo",
          data: this.lineSelect,
        });
      }
    },
    closeLine(index) {
      if (index > -1) {
        this.lineSelect.splice(index, 1);
      }
      this.updateValues(this.lineSelect);
    },
    openApprovalDetail(index) {
      const id = this.$route.params.solicitation_id;
      this.$router.push({
        name: 'approval-detail',
        params: { index, id },
      });
    },
    async copyLinkDocument(index) {
      try {
        this.loadingCopyLink = true;
        const params = {
          index: index,
          solicitation_id: this.$route.params.solicitation_id
        }

        await this.loadLinkApproveGerarTermo(params);

        const message = `📄 *Documento para aprovação:*\n\nClique no link abaixo 👇\n${this.link_gerar_termo}`;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(message);
          await this.$swal({
            title: "Link copiado!",
            text: "O link foi copiado para a área de transferência.",
            icon: "success",
            timer: 1500,
            showConfirmButton: false
          });
        } else {
          const textarea = document.createElement("textarea");
          textarea.value = message;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
          await this.$swal({
            title: "Link copiado!",
            text: "O link foi copiado para a área de transferência.",
            icon: "success",
            timer: 1500,
            showConfirmButton: false
          });
        }
        this.loadingCopyLink = false;
      } catch (error) {
        await this.$swal("Oops..", error.message, "error");
        this.loadingCopyLink = false;
      }

    },
  }
};
</script>
<style scoped>
.headerClass {
  white-space: nowrap;
  word-break: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
